import React, { Component } from "react";

export default class footer extends Component {
  render() {
    return (
      <div className="site-footer" id="footer">
        <div className="container">
          <div>
          <span>{this.props.siteName}</span>
          </div>
          <div>
          <a href="tel:+381611872933">+38161 18 72 933</a>
          </div>
          
        </div>
      </div>
    );
  }
}
